module.exports = __webpack_public_path__ + "assets/img/70b305f1ac12f16cd8c95ef2e85445f1.png";